import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { IGroup } from '../../groups/IGroups';
import { ReminderReviewPeriodModel } from './reminder-review-period.model';
import { ReminderScheduleType } from './reminder-schedule-type.model';
import { ReminderType } from './reminder-type.model';
import * as ReminderActions from './reminder.actions';
import { Reminder } from './reminder.model';

export const remindersFeatureKey = 'reminders';

export interface State extends EntityState<Reminder> {
    reminderTypes: ReminderType[];
    reminderReviewPeriods: ReminderReviewPeriodModel[];
    reminderScheduleTypes: ReminderScheduleType[];
    recipients: IGroup[];
}

export const adapter: EntityAdapter<Reminder> = createEntityAdapter<Reminder>({
    selectId: (model: Reminder) => model.Reminderinstanceid
});

export const initialState: State = adapter.getInitialState({
    reminderTypes: [],
    reminderReviewPeriods: [],
    reminderScheduleTypes: [],
    recipients: []
});

const reminderReducer = createReducer(
    initialState,
    on(ReminderActions.addReminder, (state, action) =>
        adapter.addOne(action.reminder, state)
    ),
    on(ReminderActions.upsertReminder, (state, action) =>
        adapter.upsertOne(action.reminder, state)
    ),
    on(ReminderActions.addReminders, (state, action) =>
        adapter.addMany(action.reminders, state)
    ),
    on(ReminderActions.upsertReminders, (state, action) =>
        adapter.upsertMany(action.reminders, state)
    ),
    on(ReminderActions.updateReminder, (state, action) =>
        adapter.updateOne(action.reminder, state)
    ),
    on(ReminderActions.updateReminders, (state, action) =>
        adapter.updateMany(action.reminders, state)
    ),
    on(ReminderActions.deleteReminder, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(ReminderActions.deleteReminders, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(ReminderActions.loadReminders, (state, action) =>
        adapter.setAll(action.reminders, state)
    ),
    on(ReminderActions.loadReminderScheduleTypes, (state, action) => ({
        ...state,
        reminderScheduleTypes: action.reminderScheduleTypes
    })),
    on(ReminderActions.loadReminderTypes, (state, action) => ({
        ...state,
        reminderTypes: action.reminderTypes
    })),
    on(ReminderActions.loadReminderRecipients, (state, action) => ({
        ...state,
        recipients: action.recipients
    })),
    on(ReminderActions.clearReminders, state => adapter.removeAll(state)),
    on(ReminderActions.loadReminderReviewPeriods, (state, action) => ({
        ...state,
        reminderReviewPeriods: action.reminderReviewPeriods
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return reminderReducer(state, action);
}
